import * as types from './mutation_types';

export default {
  [types.VIDEO_CREATE_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.VIDEO_CREATE_TOGGLE_LOADING](state) {
    Object.assign(state, { error: '', isLoading: !state.isLoading });
  },

  [types.VIDEO_CREATE_SET_CREATED](state, created) {
    Object.assign(state, { created });
  },

  [types.VIDEO_CREATE_SET_VIOLATIONS](state, violations) {
    Object.assign(state, { violations });
  },

  [types.VIDEO_CREATE_RESET](state) {
    Object.assign(state, {
      created: null,
      error: '',
      isLoading: false,
      violations: null,
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/video/create/mutations.js